import React from "react";
import { Route, Redirect } from "react-router-dom";
import Cookie from "js-cookie";

function PrivateRoute({ children, ...rest }) {
	const adminInfo = Cookie.get("adminInfo");
	let currentUser = {};
	if (adminInfo) {
		currentUser = JSON.parse(adminInfo);
	}

	return (
		<Route
			{...rest}
			render={({ location }) =>
				adminInfo ? (
					location.pathname !== "/" ? (
						children
					) : currentUser.role && currentUser.role !== "shipper" ? (
						<Redirect to={{ pathname: "/admins", state: { from: location } }} />
					) : (
						<Redirect
							to={{ pathname: "/shipping-labels", state: { from: location } }}
						/>
					)
				) : (
					<Redirect
						to={{
							pathname: "/login",
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}

export default PrivateRoute;
